module.exports = __webpack_public_path__ + "static/media/wizafy-explore.9148c6cd.jpg";